export const DEFAUL_DEVICES_TAKE = 40
